<template>
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="offset-2 col-8">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">中央大學企業重整/再生與破產法制研究中心</h1>
                  </div>
                  <form>
                    <div class="form-group">
                      <label for="email">帳號</label>
                      <input type="email" class="form-control form-control-user" id="email" aria-describedby="emailHelp"  v-model="email" autocomplete="email">
                    </div>
                    <div class="form-group">
                      <label for="password">密碼</label>
                      <input type="password" class="form-control form-control-user" id="password"  v-model="password" autocomplete="current-password">
                    </div>
                    <div class="form-group">
                      <label for="password">驗證碼</label>
                      <input type="text" class="form-control form-control-user" v-model="codevalue" style="text-transform:uppercase"> 
                      <input type="button" id="code" class="btn-lpicma mt-2"  v-model="checkCode"/> 
                      <i class="fa fa-redo refresh" @click="createCode" ></i>

                    </div>
            
                    <hr>
                    <div class="form-group" style="text-align:center">
                      <button type="button" class="btn btn-secondary"  v-on:click="Clean" >清除</button>
                      <button type="button" class="btn btn-primary"  v-on:click="Login" >登入</button>
                    </div>
                  </form>
                </div>
              </div>
              
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>
<script>
import {fb, db } from '../firebase'
export default {
  name: 'Login',
  data () {
    return {
      email:'',
      password:'',
      checkCode:'',
      codevalue:'',
      data:''
    }
  },
  mounted () {
    var login = localStorage.getItem("login");
    if (login)  this.$router.push({name: 'Home'});
  },
  created(){
      this.createCode();
  },
  methods: {
    AuthData() {
        if ( this.email == '') {
          alert("請填入Email!");
          return false;
        } else if ( this.password == '') {
          alert("請填入Password!");
          return false;
        } else if ( this.codevalue == '') {
          alert("請填入驗證碼!");
          return false;
        } else if (this.codevalue.toUpperCase() != this.checkCode) {
          alert("驗證碼輸入錯誤!");
          this.createCode();
          this.codevalue = '';
          return false;
        }
        return true;
    },  
    Login() {
      
      var vm = this;
      if (this.AuthData()) {


        db.collection("admin").where("email", "==", this.email).get().then((querySnapshot) => {
        
            if (querySnapshot.size == 1) {
              var id ;
              querySnapshot.forEach((doc) => {
                this.data = doc.data();
                id = doc.id;
              });

              if ( this.data.is_disabled ) {
                 alert('此帳號停權中!');
              } else if ( this.data.password == this.password ) {
                localStorage.setItem("login", true); 
                localStorage.setItem("user_id", id);
                localStorage.setItem("is_superuser", this.data.is_superuser )
                localStorage.setItem("user_data", JSON.stringify(this.data.permission))
                alert("登入成功!");
                this.$router.push({name: 'Home'});
              } else {
                 alert('密碼錯誤，請再次檢查密碼');
              }
              
            } else {
              alert('無此使用者，請重新確認帳號');
            }
        });


      }
    },
    Clean(){
      this.email = '';
      this.password = '',
      this.codevalue = ''
    },
    createCode(){
        var code = "";    
        var codeLength = 4;
        var random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R',   
          'S','T','U','V','W','X','Y','Z'); 
        for(var i = 0; i < codeLength; i++) {  
            var index = Math.floor(Math.random()*36);
            code += random[index];
        }   
            this.checkCode = code;  
    }
  }
}
</script>
<style scoped>

.btn-lpicma {
   font-size: 18px;
    letter-spacing:3px;
    color: #053d84;
    background: #cdcbcb;
    border:0;
    cursor: auto;
}
.refresh {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue